import React from 'react';
import styles from './styles.module.scss';
import bgThg from 'assets/img/bg_thg.png';
import bgThg2 from 'assets/img/bg_thg_2.png';
import { benefitOptions } from './config';

const Benefits = () => {
  const renderContent = benefit => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.card,
      key: benefit.title
    }, /*#__PURE__*/React.createElement("img", {
      src: benefit.imgSrc,
      className: styles.icon
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.label
    }, /*#__PURE__*/React.createElement("span", null, benefit.title)), /*#__PURE__*/React.createElement("div", {
      className: styles.remarkable
    }, /*#__PURE__*/React.createElement("span", null, benefit.remarkable)), /*#__PURE__*/React.createElement("div", {
      className: styles.info
    }, /*#__PURE__*/React.createElement("span", null, benefit.info)));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("img", {
    src: bgThg,
    className: styles.bgTHG
  }), /*#__PURE__*/React.createElement("img", {
    src: bgThg2,
    className: styles.bgTHGRight
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.benefitWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "Benefits")), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, benefitOptions.map(renderContent)))));
};

export default Benefits;